<template>
  <div :id="id">
    <div class="column-title">k/件</div>
  </div>
</template>
<script>
import G2 from "@antv/g2";

export default {
  name: "columnchart",
  props: ["chartData", "chartId"],
  data() {
    return {
      data: [],
      id: "",
      chart: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      // console.log(newVal)
      this.chart.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    // let max = 0;
    // this.data.forEach(e => {
    //   if (e.value > max) {
    //     max = e.value
    //   }
    // })
    // console.log(max);
    this.chart = new G2.Chart({
      container: this.id,
      forceFit: true,
      height: document.querySelector("#" + this.id + "").clientHeight,
      width: document.querySelector("#" + this.id + "").clientWidth,
      padding: [38, 0, 37, 30]
    });
    this.chart.source(this.data);
    // this.chart.scale('value', {
    //   tickInterval: max / 2
    // });
    this.chart.axis('date', {
      label: {
        textStyle: {
          fill: '#fff',
          fontSize: 12
        }
      },
      tickLine: {
        alignWithLabel: false,
        length: 0
      },
      line: {
        lineWidth: 1,
        stroke: '#3fe8f6'
      }
    });
    this.chart.axis('value', {
      label: {
        textStyle: {
          fill: '#fff',
          fontSize: 12
        }
      },
      line: {
        lineWidth: 1,
        stroke: '#3fe8f6'
      }
    });
    this.chart.intervalStack().position('date*value').color('name', ['#3fe8f6', '#fd8c3c']).size(11).label('value', {
      textStyle: {
        fill: '#fff'
      },
      offset: 10
    }).tooltip('name*value', (name, value) => {
      return {
        name: name==='total'?'转入纠纷事件数':'转入调解事件数',
        value: value
      };
    });
    this.chart.render();
  }
};
</script>
<style lang="scss">
#trend-chart {
  position: relative;
  width: 100%;
  height: 100%;
  .column-title {
    position: absolute;
    left: 8px;
    top: 8px;
    color: #fff;
    font-size: 12px;
  }
}
</style>
